import React, { useEffect, useState } from "react";
import "./VideoPopup.css";
import Introvid from "../Assets/about-pranesh.mp4"

const VideoPopup = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 10000); // 10 seconds

    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div className="video-popup-overlay">
      <div className="video-popup-content">
        <button className="video-popup-close" onClick={() => setShow(false)}>
          ✕
        </button>
        
        <video controls autoPlay muted>
          <source src={Introvid} type="video/mp4" />
        </video>
       
      </div>
    </div>
  );
};

export default VideoPopup;
